/**
 * 子话题表格组件
 */
import React, { useMemo, useState } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import type { TRequestBackType } from '@op/utils/requestUtil';
import { DBO_V } from '@op/utils/format';
import useLanguage from '@op/hooks/useLanguage'; 
import { SortBy } from 'tea-component/lib/table/addons';

interface ISubTopicTableChartProps {
  data?: TRequestBackType;
  getDisplayName: (val: string) => string;
}

const SubTopicTableChart: React.FC<ISubTopicTableChartProps> = ({
  data,
  getDisplayName,
}) => {
  const { formatMessage } = useLanguage();
  const sortState = useState<SortBy<any>>({ by: 'date', order: 'desc' });

  // 表格列配置
  const columns = useMemo(() => {
    const cols: any[] = [
      {
        key: 'date',
        header: formatMessage({ id: 'Date' }),
        width: 120,
      },
    ];
 
    // 添加每个系列的列
    data?.legend?.forEach((name) => {
      cols.push({
        key: name,
        align: "right",
        header: getDisplayName(name),
        render: (record: any) => { 
          return DBO_V.reviews(record[name] || 0);
        },
        width: 180,
      });
    });

    return cols;
  }, [data, getDisplayName]);

  // 可排序列
  const sortColumns = useMemo(() => {
    const keys = ['date'];
    data?.series?.forEach((item) => {
      keys.push(item.name);
    });
    return keys;
  }, [data]);

  // 表格数据
  const records = useMemo(() => { 
    return data?.tableRecord || [];
  }, [data]);

  return (
    <TableCommonHook
      className="dbo-sub-topic-trend__table"
      recordKey={(item) => item.date}
      columns={columns}
      records={records}
      hasPageable={false}
      maxHeight={350}
      sortType="local"
      // sortColumns={sortColumns}
      sortInfo={sortState}
    />
  );
};

export default SubTopicTableChart;
